<div class="bg-gradient-to-b from-slate-900 to-slate-800 text-white shadow-2xl border-b border-blue-800/50 sticky top-0 z-50 backdrop-blur-sm"
>
  <div class="flex items-center justify-between px-4 py-2 relative overflow-hidden">
    <!-- Animated Background Gradient -->
    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-blue-800/20 to-transparent animate-shimmer"></div>
    
    <!-- Left Section -->
    <div class="flex items-center justify-center gap-4 relative z-10 mt-1 "
    [ngClass]="{
      'pl-0 opacity-0 pointer-events-none': sidebarMode === 'hidden',
      'pl-24': sidebarMode === 'narrow' && !isHovering,
      'pl-72': sidebarMode === 'expanded' || (sidebarMode === 'narrow' && isHovering)
    }">
     <app-sub-menu-tabs ></app-sub-menu-tabs>
   
    </div>

    <!-- Right Section -->
    <div class="flex items-center gap-2 relative z-30">
      <!-- Search Button with pulse effect -->
      <button
        (click)="searchOverlay.toggle($event)"
        aria-label="Search"
        type="button"
        class="rounded-full bg-blue-800/30 w-10 h-10 flex items-center justify-center hover:bg-blue-700/50 hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-lg hover:shadow-xl group relative"
        pTooltip="Search" tooltipPosition="bottom" tooltipStyleClass="small-tooltip"
      >
        <i class="pi pi-search text-slate-200 text-lg group-hover:text-white group-hover:scale-110 transition-all duration-300"></i>
        <span class="absolute inset-0 rounded-full bg-blue-400 opacity-0 group-hover:opacity-20 group-hover:animate-ping"></span>
      </button>
      
      <!-- Inbox Button with notification badge -->
      <button
        (click)="navigateToNotif()"
        aria-label="Inbox / Outbox"
        type="button"
        class="rounded-full bg-blue-800/30 w-10 h-10 flex items-center justify-center hover:bg-blue-700/50 hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-lg hover:shadow-xl group relative"
        pTooltip="Inbox / Outbox" tooltipPosition="bottom"
      >
        <i class="pi pi-inbox text-slate-200 text-lg group-hover:text-white group-hover:rotate-12 transition-all duration-300"></i>
        <!-- Optional: Notification badge -->
        <span class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-blue-950 animate-pulse"></span>
      </button>
      
      <!-- Logout Button with hover effect -->
      <button
        (click)="showLogoutPopup()"
        aria-label="Logout"
        type="button"
        class="rounded-full bg-blue-800/30 w-10 h-10 flex items-center justify-center hover:bg-red-600/80 hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-red-400 focus:outline-none shadow-lg hover:shadow-xl group"
        pTooltip="Logout" tooltipPosition="bottom" tooltipStyleClass="small-tooltip"
      >
        <i class="pi pi-sign-out text-slate-200 text-lg group-hover:text-white group-hover:translate-x-1 transition-all duration-300"></i>
      </button>
      
      <!-- User Info Button with avatar glow -->
      <div class="flex items-center gap-2 py-1 px-3 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-300">
        <div class="flex flex-col items-end justify-center leading-[1.1] pr-1">
          <span class="font-bold text-white text-[11px] uppercase tracking-tight">
            {{first_name}} {{last_name}}
          </span>
          <div class="flex items-center gap-1">
            <span class="text-[10px] font-medium text-white uppercase tracking-wider">
              {{login_name}}
            </span>
            <span class="w-1 h-1 rounded-full bg-green-500 animate-pulse"></span>
          </div>
        </div>
      
        <div
          class="relative w-8 h-8 flex items-center justify-center rounded-full border-2 border-white shadow-[0_4px_10px_rgba(37,99,235,0.3)] hover:bg-blue-700 hover:scale-105 active:scale-95 transition-all duration-200 group"
        >
        <i class="pi pi-user text-white text-sm z-10"></i>
          <div class="absolute inset-0 rounded-lg bg-blue-400 opacity-0 group-hover:opacity-20 blur-sm transition-opacity"></div>
        </div>
      </div>
      
 
      
      <!-- Search Overlay Panel with enhanced design -->
      <p-overlayPanel #searchOverlay [dismissable]="true" [showCloseIcon]="false" [appendTo]="'body'">
        <div class="bg-white rounded-xl p-5 min-w-[340px] shadow-2xl animate-slideDown">
          <div class="relative mb-4 group">
            <input 
              type="text" 
              pInputText 
              [(ngModel)]="searchQuery" 
              placeholder="Search anything..." 
              (keyup.enter)="onSearch(); searchOverlay.hide()"
              class="w-full pl-10 pr-3 py-3 border-2 border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-blue-400"
            />
            <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-hover:text-blue-500 transition-colors duration-300"></i>
          </div>
          <div class="flex gap-2 justify-between">
            <button
              type="button"
              (click)="clearSearch()"
              class="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 font-medium py-2.5 px-2.5 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-md"
            >Clear</button>
            <button
              type="button"
              (click)="onSearch(); searchOverlay.hide()"
              class="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium py-2.5 px-2.5 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >Search</button>
          </div>
        </div>
      </p-overlayPanel>
    </div>
  </div>
</div>

<!-- Logout Confirmation Dialog with enhanced animation -->
<div
  *ngIf="showLogout"
  class="fixed inset-0 z-[2100] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn"
>
  <div
    class="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 relative animate-scaleIn"
  >
    <button
      (click)="showLogout = false"
      aria-label="Close"
      class="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 hover:bg-red-100 text-slate-400 hover:text-red-600 transition-all duration-300 text-xl flex items-center justify-center hover:scale-110 hover:rotate-90"
      type="button"
    >&times;</button>
    <div class="p-4 flex flex-col items-center">
      <div class="w-20 h-20 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center mb-4 animate-bounce-slow relative">
        <i class="pi pi-sign-out text-red-600 text-3xl"></i>
        <span class="absolute inset-0 rounded-full bg-red-400 opacity-0 animate-ping"></span>
      </div>
      <h3 class="text-2xl font-bold text-slate-800 mb-2">Confirm Logout</h3>
      <p class="text-center text-slate-600 mb-6 leading-relaxed">
        Are you sure you want to exit the application? Any unsaved changes may be lost.
      </p>
      <div class="w-full flex gap-3">
        <button
          (click)="showLogout = false"
          class="flex-1 flex items-center justify-center bg-slate-200 hover:bg-slate-300 text-slate-700 font-medium py-3 px-6 rounded-lg transition-all duration-300 hover:scale-105"
        >
          Cancel
        </button>
        <button
          (click)="logout()"
          class="flex-1 flex items-center justify-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 gap-2 hover:scale-105 shadow-lg hover:shadow-xl group"
        >
          <i class="pi pi-sign-out group-hover:translate-x-1 transition-transform duration-300"></i>
          Logout
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Role Selection Dialog with enhanced styling -->
<div
  *ngIf="displayDialog"
  class="fixed inset-0 z-[2050] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn"
>
  <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 relative animate-scaleIn">
    <button
      (click)="displayDialog=false"
      aria-label="Close"
      class="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 hover:bg-red-100 text-slate-400 hover:text-red-600 transition-all duration-300 text-xl flex items-center justify-center hover:scale-110 hover:rotate-90"
      type="button"
    >&times;</button>
    <div>
      <div class="flex items-center gap-3 mb-6">
        <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg">
          <i class="pi pi-users text-white text-xl"></i>
        </div>
        <h2 class="text-2xl font-bold text-slate-800">Select Role</h2>
      </div>
      <div class="mt-4">
        <p-dropdown 
          class="w-full hover:shadow-md transition-shadow duration-300" 
          [options]="roles" 
          [filter]="true" 
          filterBy="name" 
          [(ngModel)]="selectedRole" 
          optionLabel="role_name"
          filterBy="role_name" 
          placeholder="Select a Role" 
          inputId="role" 
          (onChange)="confirmRoleChange()"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>
  </div>
</div>

<!-- Notifications Sidebar with enhanced design -->
<p-sidebar 
  [(visible)]="showNotification" 
  position="right" 
  [modal]="true" 
  [closeOnEscape]="true"
  [style]="{ width: '420px', 'z-index': '2000' }" 
  [baseZIndex]="2000" 
  (onShow)="disableBodyScroll()" 
  (onHide)="enableBodyScroll()"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center shadow-lg">
        <i class="pi pi-bell text-white"></i>
      </div>
      <h3 class="text-xl font-bold text-slate-800">Notifications</h3>
    </div>
  </ng-template>
  <hr class="border-slate-200 my-3" />
  <div class="flex justify-end mb-3" *ngIf="groupedNotifications.length > 0 && hasUnreadNotifications()">
    <button
      type="button"
      (click)="markAsRead()"
      class="text-blue-600 hover:text-blue-700 font-medium text-sm px-4 py-2 rounded-lg hover:bg-blue-50 transition-all duration-300 hover:scale-105"
    >
      Mark as Read
    </button>
  </div>
  <div *ngIf="groupedNotifications.length === 0" 
    class="flex flex-col items-center justify-center py-20 text-center animate-fadeIn">
    <div class="w-20 h-20 bg-gradient-to-br from-slate-100 to-slate-200 rounded-full flex items-center justify-center mb-4">
      <i class="pi pi-info-circle text-slate-400 text-4xl"></i>
    </div>
    <p class="text-slate-500 font-medium text-lg">No activity found</p>
  </div>
  <div *ngFor="let group of groupedNotifications" class="mb-6 animate-slideIn">
    <h4 class="text-sm font-bold text-slate-700 uppercase tracking-wide mb-3 flex items-center gap-2">
      <span class="w-2 h-2 bg-blue-600 rounded-full"></span>
      {{ group.dateLabel }}
    </h4>
    <div *ngFor="let notif of group.notifications" 
      class="bg-white rounded-xl border-2 border-slate-200 p-4 mb-3 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer group"
      [ngClass]="{ 'bg-slate-50': notif.view, 'bg-blue-50 border-blue-300 shadow-md': !notif.view }">
      <div class="flex justify-end gap-2 mb-2">
        <button
          type="button"
          (click)="onViewNotification(notif)"
          title="View Notification"
          class="text-blue-600 hover:text-white hover:bg-blue-600 text-sm font-medium px-3 py-1.5 rounded-lg transition-all duration-300 hover:scale-105"
        >View</button>
        <button
          type="button"
          (click)="closeNotification(notif)" 
          title="Dismiss"
          class="text-red-600 hover:text-white hover:bg-red-600 p-2 rounded-lg transition-all duration-300 hover:scale-105 flex items-center"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
          <i class="pi pi-inbox text-blue-600 text-lg"></i>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-slate-800 font-medium mb-1 leading-snug group-hover:text-blue-600 transition-colors duration-300">{{ notif.message }}</p>
          <p class="text-xs text-slate-500 flex items-center gap-1">
            <i class="pi pi-clock text-xs"></i>
            {{ notif.created_on | date: 'dd MMM yyyy | hh:mm a' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>

<style>
@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce-slow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.animate-shimmer {
  animation: shimmer 3s infinite;
}

.animate-slideIn {
  animation: slideIn 0.4s ease-out;
}

.animate-slideDown {
  animation: slideDown 0.3s ease-out;
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out;
}

.animate-scaleIn {
  animation: scaleIn 0.3s ease-out;
}

.animate-bounce-slow {
  animation: bounce-slow 2s infinite;
}
</style>